import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const TONE_COLOR = {
    success: 'var(--success)',
    warning: 'var(--warning)',
    danger: 'var(--critical)',
    neutral: 'var(--text-dim)',
};
function scoreColor(score) {
    if (score >= 85)
        return 'var(--success)';
    if (score >= 60)
        return 'var(--warning)';
    return 'var(--critical)';
}
function scoreLabel(score) {
    if (score >= 85)
        return 'At target';
    if (score >= 60)
        return 'Gap';
    return 'Blocker';
}
export function ScoreBar({ score, width = '100%', className, tone, hideLabel }) {
    const clamped = Math.max(0, Math.min(100, score));
    const fill = tone ? TONE_COLOR[tone] : scoreColor(clamped);
    return (_jsxs("div", { className: className, "data-score-bar": true, role: "img", "aria-label": hideLabel ? `${clamped} of 100` : `${clamped} of 100 — ${scoreLabel(clamped)}`, style: {
            display: 'grid',
            gridTemplateColumns: hideLabel ? 'auto 1fr' : 'auto 1fr auto',
            gap: 'var(--space-2)',
            alignItems: 'center',
            width,
            fontFamily: 'var(--font-ui)',
        }, children: [_jsxs("span", { style: { fontFamily: 'var(--font-mono)', fontSize: 'var(--font-size-3xs)', color: 'var(--text-dim)' }, children: [clamped, "/100"] }), _jsx("span", { "aria-hidden": "true", style: {
                    height: '6px',
                    background: 'var(--border)',
                    borderRadius: 'var(--radius-chip)',
                    overflow: 'hidden',
                }, children: _jsx("span", { style: { display: 'block', width: `${clamped}%`, height: '100%', background: fill } }) }), hideLabel ? null : (_jsx("span", { style: {
                    fontSize: 'var(--font-size-3xs)',
                    color: scoreColor(clamped),
                    fontWeight: 500,
                    minWidth: '5ch',
                }, children: scoreLabel(clamped) }))] }));
}
//# sourceMappingURL=ScoreBar.js.map